import { createElement } from "react";
import { createRoot } from "react-dom/client";

import { AppShell } from "./components/AppShell";
import { installBrowserSecurityFetch } from "./lib/browserSecurity";

const appContainer = document.querySelector<HTMLDivElement>("#app");

if (!appContainer) {
  throw new Error("App container not found");
}

installBrowserSecurityFetch();

const root = createRoot(appContainer);
root.render(createElement(AppShell));
